<template>
  <Popover class="relative" v-slot="{ open }">
    <PopoverButton
      class="w-full h-10 border text-left rounded-full focus:outline-none px-5"
      :class="`border-${color}`"
    >
      <span class="block truncate opacity-40" v-if="!modelValue">
        {{ placeholder }}
      </span>
      <span v-else>
        <template v-if="!showIcon">
          {{ modelValue.map(x => `${x.name}`).join(' ') }}
        </template>
        <template v-else>
          <div
            class="flex flex-row items-center"
            v-for="(item, index) in modelValue"
            :key="index"
          >
            <img
              :src="require('../../assets/' + item.iconUrl)"
              class="mr-1"
              width="20"
              height="20"
            />
            {{ item.name }}
          </div>
        </template>
      </span>
      <span
        class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
      >
        <chevron-icn
          width="20px"
          height="20px"
          :class="`${color}-icon`"
          :style="open ? 'transform: scale(1, -1)' : ''"
        />
      </span>
    </PopoverButton>
    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0"
    >
      <PopoverPanel
        class="w-full border bg-white px-1 py-1 mt-1 absolute z-10"
        style="border-radius: 20px;"
        :class="`border-${color}`"
      >
        <table>
          <tbody>
            <tr v-for="rowIndex in Math.ceil(items.length / 3)" :key="rowIndex">
              <td v-for="index in 3" :key="`td-${index}`">
                <PopoverButton>
                  <button
                    type="button"
                    v-if="items[index - 1 + (rowIndex - 1) * 3]"
                    :class="[
                      'h-7 w-52 text-left pl-5',
                      result.includes(items[index - 1 + (rowIndex - 1) * 3])
                        ? `bg-${color} text-white font-bold`
                        : `text-${color}`,
                    ]"
                    style="border-radius: 20px;"
                    @click="toggleItem(items[index - 1 + (rowIndex - 1) * 3])"
                  >
                    <div class="flex flex-row items-center">
                      <template
                        v-if="items[index - 1 + (rowIndex - 1) * 3].iconUrl"
                        ><img
                          :src="
                            require('../../assets/' +
                              items[index - 1 + (rowIndex - 1) * 3].iconUrl)
                          "
                          class="mr-1"
                          width="20"
                          height="20"
                        />
                      </template>
                      {{ items[index - 1 + (rowIndex - 1) * 3].name }}
                    </div>
                  </button>
                </PopoverButton>
              </td>
            </tr>
          </tbody>
        </table>
      </PopoverPanel>
    </transition>
  </Popover>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'

import ChevronIcn from '@/assets/icons/chevron.svg?inline'

import { reactive } from 'vue'

export default {
  name: 'AppSelectFilter',

  components: {
    Popover,
    PopoverButton,
    PopoverPanel,
    ChevronIcn,
  },

  emits: ['update:modelValue'],
  props: {
    color: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    showIcon: Boolean,
    /*
      v-model
      example
        [
          { name: "調査研究費", selected: false },
          { name: "研修費", selected: false },
          { name: "広報費", selected: false }, ...
        ]
    */

    modelValue: Array,
  },

  setup(props, context) {
    let result = reactive([])
    const display = () => result.map(item => item.name).join(', ')
    const toggleItem = item => {
      const index = result.indexOf(item)
      if (props.multiple) {
        if (index === -1) {
          result.push(item)
        } else {
          result.splice(index, 1)
        }
      } else {
        if (result.length > 0) result.pop()
        result.push(item)
      }

      context.emit('update:modelValue', result)
    }
    return { toggleItem, display, result }
  },
}
</script>

<style lang="scss" scoped>
#headlessui-popover-panel-4 {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
</style>
